//import {React, useEffect, useState} from 'react'; 
/* eslint-disable no-unused-vars */
/* eslint-disable-next-line*/
import React, { useRef, useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Page from '../../components/Page';
import {Typography, makeStyles, colors, DialogTitle} from '@material-ui/core';
//import { GetStartedContent } from "./getStartedContent";
import Navbar from './Navbar';
import './Navbar.css';
import NavbarLower from './NavbarLower';

import { Badge,Table, TableHead, TableRow, TableCell, TableBody, TablePagination, TextField,TableContainer, Paper,IconButton,  Dialog,DialogActions,DialogContent, Button} from '@mui/material';
import { Search as SearchIcon} from '@mui/icons-material';
import {useStyles} from '../pages/SelfService';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
//import SidebarNav from '../../layouts/Main/components/Sidebar';
import ZoomOutMapOutlinedIcon from '@mui/icons-material/ZoomOutMapOutlined';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import { pink, red, green, orange, yellow } from '@mui/material/colors';
import CircleIcon from '@mui/icons-material/Circle';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import LoadingButton from '@mui/lab/LoadingButton';
import { Formik, Form, Field } from 'formik';
import * as Yup from "yup";
import Swal from "sweetalert";
import UncontrolledExample from '../../components/Carousel/Carousel';
import Footer from '../pages/Footer';

//import Button from '@mui/material/Button';

//Adding the validation for the update status.
const UpdateStatusSchema = Yup.object().shape({ 
  requeststatus: Yup.string().required('Required'), 
  reason: Yup.string().required('Required'), 
  //userid: Yup.string().required('Required'), 
 });

 const useStylesSelect = makeStyles((theme) => ({
  select: {
    '& .MuiSelect-select': {
      paddingRight: theme.spacing(3),
    },
  },
  button: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    borderRadius: 0,
  },
}));
//Create a page that displays the all the submitted requests
const DisplayRequests=()=>{
  const classes =  useStyles();
  const classStyles=useStylesSelect();
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  //For sets data state for the fetching of data.
  const [data, setRequestData] = useState([]);
  
  const [newCount, SetNewCount]= useState([]);
  //Creating a component to manage the update of a service request status

  //Setting the loading button state
  const [loading, setLoading] = useState(false);

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));
  //Setting the Pagination events and state.
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const [open, setOpen] = useState(false);

  //open the dialog for the status change
  const [previewOpen, setPreviewOpen] = useState(false);
    //Function to handle to return a correct function on each call
    // Storing the dialog data in a state.
  const [dialogData, setDialogData]= useState([]);
  const previewDialogClick=(item, index)=>{
    setPreviewOpen(true); 
    setDialogData(item);
    console.log(item);

  }

  const handlePreviewClose = () => {
    setPreviewOpen(false);
  };
  //Defining the available status.
  const statusEnums=["NEW","PROCESSING","APPROVED","REJECTED"];


  const [selectedOption, setSelectedOption] = React.useState('');
  const handleChange1 = (event) => {
    setSelectedOption(event.target.value);
  };
  //Get Service requests from an API so that it can display in the UI.
  //const accesstoken="eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJ0ZXN0dXNlciIsImlhdCI6MTY4NDMwOTg2MiwiZXhwIjoxNjg0Mzk2MjYyfQ.lIoTQRy5Zf0SeRESNlm9nyQZpIWcGVBLswvU31JOKCsAdJ4xeInNWZFfOA1Lc6y4rr5irJuuliWmJnsk0QXw2g";
  const fetchServiceRequests= async()=>{
    const axios = require('axios');
    let data1 = '';
    
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: 'http://localhost:8099/api/v1/servicerequest/',
      headers: {
        'Authorization': `Bearer ${accesstoken}`,
       },
      data : data1
    };
    
    axios.request(config)
    .then((response) => {
      console.log(response.data.data);
      if(response.data.data.length===0){
        setRequestData(response.data.data)
      }
      else{
        //Gets an update of the data.
        setRequestData(response.data.data);
        console.log(response.data.data.policy)
      }
      

    })
    .catch((error) => {
      console.log(error);
    });
  };
  //Get the count for the New Requests
  const getNewRequestsCount= async()=>{
    const axios = require('axios');
    let data = '';
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: 'http://localhost:8099/api/v1/servicerequest/countnew',
      headers: {
        'Authorization': `Bearer ${accesstoken}`,
       },
      data : data
    };
    
    axios.request(config)
    .then((response) => {
      console.log(JSON.stringify(response.data));
      console.log(response.data)
      SetNewCount(response.data.data);
    })
    .catch((error) => {
      console.log(error);
    });
  }
  
  //Use Effect to manage fetching of the data when the component mounts
  useEffect(()=>{
    fetchServiceRequests(); 
    getNewRequestsCount();
  },[]);

  //Approve or reject a request API Call (Change the status of the request)
  const ref = useRef(null);
  const accesstoken='eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJ0ZXN0dXNlciIsImlhdCI6MTY4NDMyMDMzMCwiZXhwIjoxNjg0NDA2NzMwfQ.NX03DXofcxnnGw1mtxgdPM_Vs0_z9oEbZNSTjsg49tjX9rkjTN8iVAEAtqOdPYqUcoe2CUx0oQXn4_CXL8TIfA';
  const changeRequestStatus= async()=>{
    //console.log(values);
    const axios = require('axios');
    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: 'http://localhost:8099/api/v1/servicerequest/updatestatus/'+ ref.current.values.requeststatus+'/'+ref.current.values.request_id,
      headers: {
        'Authorization': `Bearer ${accesstoken}`
       }
    };
    axios.request(config)
    .then((response) => {
     console.log(JSON.stringify(response.data));
     if(response.data.message==="Success"){
      Swal({
        title: "Status Update Successful",
        text: "",
        icon: "success",
        button: "Ok",
      });
     }
     else{
      Swal({
        title: "Failed to Update",
        text: "Please try Again",
        icon: "error",
        button: "Ok",
      });
     }
    })
    .catch((error) => {
      console.log(error);
      Swal({
        title: "An Error Occurred",
        text: "Contact Admin",
        icon: "error",
        button: "Ok",
      });
    });

  }

  //Handle the submission that updates the status.
  const handleSubmitStatus = async (values) =>{
    console.log(values.status);
  }
  
  
  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);
    const result = data.filter((item) =>
      item.accountName.toLowerCase().includes(value) || item.accountNumber.toLowerCase().includes(value)
      || item.formID.toLowerCase().includes(value)
      
    );
    setFilteredData(result);
  };
    
  const renderTableData = () => {
    /*const shouldShowPrompt = !localStorage.getItem('newFeaturePromptShown3');
    if (shouldShowPrompt) {
      localStorage.setItem('newFeaturePromptShown3', true);
      return <NewFeaturePrompt />;
    }*/
    var tableData = searchTerm ? filteredData : data;
    return tableData.map((item, index) => {
      return(
      <>  
      <Dialog
            fullScreen={true}
            open={previewOpen}
            onClose={handlePreviewClose}
      >
      {/*<div><h5>Update Service Request Status for {dialogData.accountName}</h5></div>*/}
      <Grid container spacing={0}>
          <Grid item xs={12} md={12} className={classes.customer_header}>
          Update Service Request Status for {dialogData.accountName}
          </Grid>
      </Grid>
      <Formik 
       initialValues={{ 
         requeststatus: dialogData.status==='NEW' ?0:dialogData.status==='PROCESSING'? 1:dialogData.status==='APPROVED'? 2: 3,
         reason: '', 
         request_id: dialogData.id,
       }} 
       validationSchema={UpdateStatusSchema}
       innerRef={ref} 
       /*onSubmit={values => { 
         // same shape as initial values 
         console.log(values); 
       }}*/
      >
    {({ errors, touched,handleBlur,handleChange,isValid, dirty, isSubmitting, values}) => (

      <form onSubmit={changeRequestStatus}>
        <DialogContent className={classes.grid_background}>
            {/**Content for the preview */}
            <Grid container spacing={0} >
              <Grid item xs={3} md={3} >
              Select Status
              </Grid>
              <Grid item xs={3} md={3} >
              <TextField
                  error={Boolean(touched.requeststatus && errors.requeststatus)}
                  //label="Update Service Request Status"
                  name="requeststatus"
                  onChange={handleChange}
                  onBlur={handleBlur}                  
                  required
                  helperText={touched.requeststatus && errors.requeststatus}
                  select
                  SelectProps={{ native: true }}
                  value={values.requeststatus}
                  variant="outlined"
                  size="small"
              >
                <option
                    key=''
                    value=''
                    disabled
                >
                Select Status
                </option>
                {statusEnums.map((status, index) => (
                    <option
                        key={index}
                        value={index}
                    >
                    {status}
                    </option>
                ))}
              </TextField>
              </Grid>
              <Grid item xs={3} md={3} >
              Specify Reason
              </Grid>
              <Grid item xs={3} md={3} >
              <TextField
            error={Boolean(touched.reason && errors.reason)}
            helperText={touched.reason && errors.reason}
            type="text"
            label="Reason for Rejection"
            margin="normal"
            name="reason"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.reason}
            variant="outlined"
            size="small"
               />
              </Grid>
            </Grid>         
        </DialogContent>
        <DialogActions>
            <Button onClick={handlePreviewClose}>Close</Button>
            <LoadingButton type="button"
             disabled={!(dirty && isValid) || isSubmitting}
             onClick={changeRequestStatus}
             loading={loading}
             variant="outlined"
            >Update Status</LoadingButton>
        </DialogActions>
      </form>      
  )} 
  </Formik>
  
      </Dialog>

      <StyledTableRow key={index} className={classes.tableRow}>
        <TableCell>
          <ZoomOutMapOutlinedIcon
            aria-label="expand row"
            size="small"
            onClick={() => previewDialogClick(item, index)}
          >          
          </ZoomOutMapOutlinedIcon>
        </TableCell>
        <TableCell>
        {item.status==='NEW'?<CircleIcon sx={{ color:red[500]}}/>:item.status==='APPROVED'? <CircleIcon sx={{ color:green[500] }}/>:item.status==='PROCESSING'?<CircleIcon sx={{ color:orange[500] }}/>:<CircleIcon sx={{ color:yellow[500] }}/>}          
        </TableCell>
        <TableCell >{item.formID}</TableCell>     
        <TableCell >{item.mobilePhoneNumber}</TableCell>
        <TableCell >{item.accountName}</TableCell>
        <TableCell >{item.accountNumber}</TableCell>
        <TableCell >{item.idNumber}</TableCell>{/**/}
        <TableCell >{item.branchOfApplication}</TableCell>
        <TableCell >{item.limitAmount}</TableCell>
        <TableCell >{item.numberOfChequeBooks}</TableCell>       
        <TableCell>{item.chequeNumberRange}</TableCell>
        <TableCell>{item.policy}</TableCell>
        <TableCell>{item.requestDate}</TableCell>
        <TableCell>{item.stopPaymentReason}</TableCell>
        <TableCell>{item.stoppaymenttime}</TableCell>
        <TableCell>{item.timeOfRequest}</TableCell>
        {/*Options for post online services*/}
        <TableCell>
          <Typography>
            {item.postonline}
          </Typography>
        </TableCell>
        {/**Options for post mobile services */}
        <TableCell>{item.postmobile.map((postmobile, index)=>(
          <Typography key={index} variant="body1">
            {postmobile.postMobileServiceName}
          </Typography>
        ))}
        </TableCell>
        {/**Options for postBank DebitCard Replacement services */}
        <TableCell>
          <Typography  variant="body1">
            {item.postbankdebitcard}
          </Typography>
        </TableCell>
        {/**Options for Checkbooks currency services */}
        <TableCell>{item.chequebookscurrency.map((currency, index)=>(
          <Typography key={index} variant="body1">
            {currency.chequeBooksCurrencyName}
          </Typography>
        ))}
        </TableCell>
      </StyledTableRow>
      {/*This is a dialog that handles the status update for a given service request*/}
      </>)  
          
      });
    
  };


  return (
    <div>
      <Grid container >
          <Grid item xs={6} md={6}>
            <Badge max={newCount} badgeContent={newCount} color="error" >
              <NotificationsIcon />
            </Badge> New Request(s).
          </Grid>
          <Grid item xs={6} md={6}>
            <TextField
             placeholder="Search..."
             variant="outlined"
             size="small"
             value={searchTerm}
             onChange={handleSearch}
             InputProps={{
              startAdornment: <SearchIcon fontSize="small"/>,
            }}
         />
          </Grid>
      </Grid>
      <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead sx={{ height: 20 }}>
        <TableRow className={classes.grid_header}>
        <TableCell size="small" component="th" scope="row">Actions</TableCell>  
        <TableCell>Status</TableCell>
        <TableCell size="small">Form ID</TableCell>       
        <TableCell size="small">Mobile Phone Number</TableCell>
        <TableCell>Account Name</TableCell>
        <TableCell>Account Number</TableCell>
        <TableCell>ID Number</TableCell>
        <TableCell>Branch of Preference</TableCell>
        <TableCell>ATM Card Limit</TableCell>
        <TableCell>Number Of cheque Leaves</TableCell>       
        <TableCell>Cheque Number Range</TableCell>
        <TableCell>Policy</TableCell>
        <TableCell>Requested Date</TableCell>
        <TableCell>Stop Payment Reason</TableCell>
        <TableCell>Stop Payment Time</TableCell>
        <TableCell>Time of Request</TableCell>
        {/*Options for post online services*/}
        <TableCell>Post Online</TableCell>

        {/**Options for post mobile services */}
        <TableCell>Post Mobile</TableCell>
        {/**Options for postBank DebitCard Replacement services */}
        <TableCell>Postbank DebitCard</TableCell>
        {/**Options for Checkbooks currency services */}
        <TableCell>Checkbooks Currency</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {renderTableData()}
        </TableBody>
      </Table>
     </TableContainer>
     <TablePagination
      rowsPerPageOptions={[5, 10, 25]}
      component="div"
      count={data.length}
      page={page}
      onPageChange={handleChangePage}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={handleChangeRowsPerPage}
     />
    </div>
  );


}

export const GetStarted= () =>{

const classes = useStyles();
    return (
      <div>
        <Navbar/>
          <NavbarLower/>
        {/*<DisplayRequests/>*/}
        <Footer/>
      </div>
      
    );
}
export default GetStarted;